export default "__VITE_ASSET__DO_Jzj0d__"